
import LoadFile from './LoadFile';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <LoadFile></LoadFile>
  </React.StrictMode>
);
reportWebVitals();
